import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../css/why-I-chest.css";
import FooterPage from "./footer";
import WhatsAppButton from "../../components/WhatsAppButton";
import { Link } from "react-router-dom";

function WhyIchestExploreMore() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);

  const line1 = "Life is about legacy,".split(" ");
  const line2 = "I-Chest.com helps preserve it !!!".split(" ");
  const first = "Life is about legacy, I-Chest.com helps preserve it !!!".split(
    " "
  );
  const [key, setKey] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setKey((prevKey) => prevKey + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <Navbar
        expand="lg"
        fixed="top"
        bg="dark"
        variant="dark"
        aria-label="Main navigation"
        className="navbar_base"
      >
        <Container>
          <Navbar.Brand href="#" className="navbar-brand logo-image">
            <img src="./logo192v2.webp" alt="alternative" />

            <div className="App_this">
              <div className="tab_largescreen_view">
                {first.map((el, i) => (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 1,
                      delay: i / 10,
                    }}
                    key={i + key * first.length}
                  >
                    {el}{" "}
                  </motion.span>
                ))}
              </div>
              <div className="tab_movile_view">
                {line1.map((el, i) => (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 1,
                      delay: i / 10,
                    }}
                    key={i + key * line1.length}
                  >
                    {el}{" "}
                  </motion.span>
                ))}
              </div>
              <div className="tab_movile_view">
                {line2.map((el, i) => (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.25,
                      delay: i / 10,
                    }}
                    key={i + key * line2.length}
                  >
                    {el}{" "}
                  </motion.span>
                ))}
              </div>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/">Home</Nav.Link>
              {/* <Nav.Link href="/services">Services</Nav.Link> */}
              {/* x <Nav.Link href="/features">Features</Nav.Link> */}
              {/* <Nav.Link href="/">Partners</Nav.Link> */}

              {/* <Link className="partner" to="/home#aboutus">
                Partners
              </Link> */}
              <Nav.Link href="#whyichest">Why I-chest</Nav.Link>
              <Nav.Link href="/contact-us">Contact Us</Nav.Link>
              {/* <button class="button">
                      <span class="button-content">Contact Us</span>
                    </button> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className={`your-component ${show ? "fade-in-element" : ""}`}>
        <div className="whyichest_base">
          <div className="whyichest_main">
            <div className="whyichest_heading">
              <h1>
                Why I<span style={{ color: "#059212" }}>-</span>Chest.com ?
              </h1>

              <LazyLoadImage
                className="whyichest_heading_logo"
                src="/img/why.webp"
                alt="whyichest"
                effect="blur"
              />
            </div>

           <h4>Legacy Continuity and Digital Security </h4>
            <div className="whyichest_paragraph">
              <p>
                Do you have a contingency plan for unforeseen circumstances—a living transition framework ensuring a seamless handover?
                Are your vital documents safeguarded under the oversight of trusted executors?
                Have you clearly communicated your plans for inheritance, legacy,
                and beneficiaries with your family, advisors, or legal counsel?
              </p>
            </div>
            <br />

            <div className="whyichest_second_para">
              <div className="whyichest_image">
                <LazyLoadImage
                  className="whyichest_image_img"
                  src="/img/Data-Storage-Security.webp"
                  alt="secure_data_image "
                  effect="blur"
                />
              </div>
              <div className="whyichest_content">
                <p>
                  Imagine a digital sanctuary—a secure, intelligent platform designed not merely for storage but for the thoughtful transmission of your legacy.
                  Within this encrypted repository, your wealth, documents, and directives are protected and precisely delivered to your chosen heirs and stewards.

                </p>
                <br />
                <p>
                  This platform serves as both vault and bridge—connecting your lifetime of achievement to its rightful succession.
                  Trusted attorneys and trustees act as gatekeepers, ensuring your wishes are executed with integrity and precision.
                </p>
                <br />
                <div className="whyichest_last_para">
                    <p>
                        Ultimately, this is more than security—it’s empowerment. It allows you to define, control, and preserve your vision,
                        keeping your most personal affairs confidential until you choose to share them. Your legacy, your plan—organized, protected,
                        and ready for the future.
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FooterPage />
        <WhatsAppButton />
      </div>
    </>
  );
}
export default WhyIchestExploreMore;
